import React, { useState } from "react";

import useCopyDataset from "hooks/useCopyDataset";
import { Tooltip } from "react-tooltip";
import { InstantDoubleValue } from "../../../api/model/dataset/InstantDoubleValue";
import { DatasetDataInfo } from "../../../models/dataset-models";
import DatasetTooltipText from "../../basic/dataset-tooltip-text/DatasetTooltipText";
import "./DatasetButtonComponent.scss";

type DatasetButtonProps = {
    id: string;
    value: string | undefined;
    selected: boolean;
    dataset: DatasetDataInfo;
    data: InstantDoubleValue | null | undefined,
    time: Date,
    style?: React.CSSProperties,
    compactMode?: boolean,
    setIdentifiers(id: string, ctrlPressed: boolean, doubleClick: boolean): void;
}

const DatasetButtonComponent = (props: DatasetButtonProps) => {
    const [isHovered, setIsHovered] = useState(false);
    const [clickTime, setClickTime] = useState(Date.now());
    useCopyDataset(isHovered, props.dataset.title, props.dataset.identifier);

    const onButtonClick = (e: any) => {
        const now = Date.now();

        if (e.ctrlKey && now - clickTime < 300) {
            props.setIdentifiers(props.dataset.identifier as string, true, true);
        }
        if (e.ctrlKey && now - clickTime >= 300) {
            props.setIdentifiers(props.dataset.identifier as string, true, false);
        } 
        if (!e.ctrlKey && now - clickTime < 300) {
            props.setIdentifiers(props.dataset.identifier as string, false, true);
        }
        setClickTime(now);
    };

    return (<>
        <Tooltip anchorSelect={`#${props.id}`} style={{zIndex: 99999}}>
            <DatasetTooltipText data={props.data} time={props.time} dataset={props.dataset}/>
        </Tooltip>
        <div
            className={`button-clickable${props.selected ? " selected-label" : ""}${props.compactMode ? " compact-button-wrapper" : " button-wrapper"}`}
            id={props.id ? props.id : ""}
            onClick={(e) => onButtonClick(e)}
            onPointerEnter={() => setIsHovered(true)}
            onPointerLeave={() => setIsHovered(false)}
            style={props.style}
        >
            {typeof props.value === "string" ?
                <>{`${props.value  } `}{props.dataset.unit ? props.dataset.unit : ""}</>
                :
                <>N/A</>
            }
        </div>
    </>);
};

export default DatasetButtonComponent;